// Typelizer digest 94b4977602e4b7c09d215a7619828868
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /learners/schools/:school_id/students/:student_id/preferences/edit */
  edit: (
    params: { schoolId: string | number; studentId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:student_id/preferences/edit', params, options),
    method: 'get',
  }),

  /** GET /learners/schools/:school_id/students/:student_id/preferences */
  show: (
    params: { schoolId: string | number; studentId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:student_id/preferences', params, options),
    method: 'get',
  }),

  /** PATCH /learners/schools/:school_id/students/:student_id/preferences */
  update: (
    params: { schoolId: string | number; studentId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:student_id/preferences', params, options),
    method: 'patch',
  }),
}
